import MenuTable from './FooterMenuTable';

export default MenuTable;



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/FooterMenu/FooterMenuTable/index.js